import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import "./App.css";
import "./asset/css/style.css";
import "./asset/css/common.css";
import "./asset/css/map.css"; 
import Login from "./pages/Auth/Login"; 
import Dashboard from "./pages/Dashboard";
import AllUsers from "./pages/Users/AllUsers";
import UserDetail from "./pages/Users/UserDetail";
import CreateReport from "./pages/Setting/CreateReport";
import AllReports from "./pages/Setting/AllReports";
import AllSubmission from "./pages/Submission/AllSubmission";
import SubmissionDetail from "./pages/Submission/SubmissionDetail";
import UploadData from "./pages/Submission/UploadData";
import CreateCoupon from "./pages/Coupon/CreateCoupon";
import AllCoupons from "./pages/Coupon/AllCoupons";
import Faqs from "./pages/Setting/Faqs";
import Ticket from "./pages/Ticket/Ticket";
import BulkUpload from "./pages/Submission/BulkUpload";
import Allbulk from "./pages/Submission/Allbulk";
import Credits from "./pages/Credits/Credits";
import Featurelayers from "./pages/Setting/Featurelayers";

function App() {
  return (
    <Router>
    

      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
 
        <Route path="/" element={<Login />} />
        <Route path="/all-users" element={<AllUsers />} />
        <Route path="/user-detail/:id" element={<UserDetail />} />
        <Route path="/create-report" element={<CreateReport />} />
        <Route path="/all-report" element={<AllReports />} />
        <Route path="/all-submission" element={<AllSubmission />} />
        <Route path="/submission-details/:id" element={<SubmissionDetail />} />
        <Route path="/upload-data/:id" element={<UploadData />} />
        <Route path="/create-coupon" element={<CreateCoupon />} />
        <Route path="/coupons" element={<AllCoupons />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/ticket" element={<Ticket />} />
        <Route path="/bulk-update/:userId" element={<BulkUpload />} />
        <Route path="/bulk-list/:userId" element={<Allbulk />} />

     
        <Route path="/credits" element={<Credits />} />
        <Route path="/feature-layer" element={<Featurelayers />} />
   
  


 
      </Routes>
    </Router>
  );
}

export default App;
